var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.718 0.803941C11.1024 1.20047 11.0926 1.83356 10.6961 2.21798L2.15318 10.5L10.6961 18.782C11.0926 19.1664 11.1024 19.7995 10.718 20.1961C10.3336 20.5926 9.70047 20.6024 9.30394 20.218L0.529189 11.7112C0.366579 11.5598 0.234842 11.3767 0.143325 11.1718C0.0491138 10.9608 -4.47258e-07 10.7321 -4.37114e-07 10.5C-4.2697e-07 10.2679 0.0491138 10.0392 0.143325 9.82822C0.234842 9.62328 0.36658 9.44024 0.52919 9.28883L9.30394 0.782017C9.70047 0.397594 10.3336 0.407409 10.718 0.803941Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLarge);
export default __webpack_public_path__ + "static/media/arrowLeftLarge.70f94cdb864c466c2663f76b40d2cb4b.svg";
export { ForwardRef as ReactComponent };